import upperFirst from 'lodash-es/upperFirst'

import { ProductCatalogEmbroideryPlacement } from '../../../__generated__/graphql/catalog/graphql'

// TODO: Translate these somehow
export const deriveNameFromEmbroideryPlacement = (placement: ProductCatalogEmbroideryPlacement) => {
  return `${upperFirst(placement.position.toLowerCase())} ${upperFirst(
    placement.location.toLowerCase()
  )}`
}
